module.exports = __webpack_public_path__ + "img/phase2-gallery-01.df3d95f7.png";